import { Reducer } from "redux";

import { LogContractIdPBPDetailsResponse } from "../models/api/Patient";
import { LogContractIdPBPDetailsDispatchTypes } from "../models/dispatchTypes/Patient";
import { LogContractIdPBPDetailsActionDispatchTypes } from "../constants/Patient";

const initialState: LogContractIdPBPDetailsResponse = {
  loading: false,
  response: false,
  error: null,
};

const PostContractIdPbpDetailsReducer: Reducer<
  LogContractIdPBPDetailsResponse,
  LogContractIdPBPDetailsDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case LogContractIdPBPDetailsActionDispatchTypes.LOG_CONTRACT_ID_PBP_DETAILS_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case LogContractIdPBPDetailsActionDispatchTypes.LOG_CONTRACT_ID_PBP_DETAILS_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case LogContractIdPBPDetailsActionDispatchTypes.LOG_CONTRACT_ID_PBP_DETAILS_ERRORS: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case LogContractIdPBPDetailsActionDispatchTypes.LOG_CONTRACT_ID_PBP_DETAILS_RESET: {
      return initialState;
    }
  }
  return state;
};

export default PostContractIdPbpDetailsReducer;
